import React from 'react'

import TestClientTable from './TestClientTable'
import TestLawyerTable from './TestLawyerTable'

function TestDashData( { data , lawyers }) {
  return (
    <>
        <div>
            <TestClientTable data={data}/>
        </div>
        <div className=' mt-4'>
            <TestLawyerTable data={lawyers}></TestLawyerTable>
        </div>
    </>
    
  )
}

export default TestDashData